import { createSelector } from '@ngrx/store';
import { AppState } from '@api-ui-app/src/app/app.state';
import { State } from '@api-ui-app/src/app/ngrx/discounts.reducer';
import { Promotion } from '@api-ui-app/src/app/shared/voucher/voucher';

export const getState = (state: AppState): State => state.discounts;
export const getPromotions = createSelector(getState, (state: State): Promotion[] => state.promotions || []);
export const getPromotionsIsLoading = createSelector(getState, (state: State): boolean => state.isLoading || false);
